import { useClientApplicationFile } from '../../../../hooks/useClientApplicationFile';
import type { UploadedFiles } from '../../../../types/Shared';
import AttachmentContainer, { Attachment } from '../EnterpriseLBADevelopers/EnterpriseLBADeveloper/Attachments';

export interface ApplicationAttachmentsProps {
  field: string;
  files: UploadedFiles[];
  title: string;
  onUploadOrDeleteActionSuccess: () => void;
  applicationId: number;
  accept?: string;
}
export const ApplicationAttachments = (props: ApplicationAttachmentsProps) => {
  const { field, files: currentCategoryFiles, title, applicationId, accept, onUploadOrDeleteActionSuccess } = props;

  const { isLoading, uploadFiles, deleteFile } = useClientApplicationFile({
    onSuccess: () => {
      onUploadOrDeleteActionSuccess();
    },
  });

  return (
    <AttachmentContainer
      title={title}
      accept={accept}
      uploadConfig={{
        onUpload: (files) => {
          uploadFiles(applicationId, files, field);
        },
        isUploading: isLoading,
      }}
      isEmpty={!currentCategoryFiles || currentCategoryFiles?.length === 0}
    >
      {currentCategoryFiles?.map((doc) => (
        <Attachment
          key={doc.url}
          title={doc?.name || ''}
          doc={doc}
          deleteFileHandler={(key) => {
            deleteFile(key, applicationId);
          }}
          onClick={() => {
            window.open(doc?.url || '');
          }}
        />
      ))}
    </AttachmentContainer>
  );
};
